import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { ConsumerAdminActions } from "../actions/consumer-admin.actions";
import { VendorAdminActions } from "../actions/vendor-admin.actions";
import { UsersState } from "../models/users-state";

const initialState: UsersState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(ConsumerAdminActions.users.getSuccess, (state, action) => ({
		...state,
		..._.omit(action, "type")
	})),
	on(VendorAdminActions.users.getSuccess, (state, action) => ({
		...state,
		..._.omit(action, "type")
	})),
	on(ConsumerAdminActions.users.getFail, (state, action) => ({
		...state,
		..._.omit(action, "type")
	})),
	on(VendorAdminActions.users.getFail, (state, action) => ({
		...state,
		..._.omit(action, "type")
	})),
	on(ConsumerAdminActions.user.removeSuccess, (state, action) => removeUser(action, state)),
	on(VendorAdminActions.user.removeSuccess, (state, action) => removeUser(action, state))
);

export function usersReducer(state: UsersState | undefined, action: Action) {
	return reducer(state, action);
}

function removeUser(action, state: UsersState): UsersState {
	const newState = { ...state };
	newState.users = _.filter(newState.users, (u) => u.userId !== action.id);
	return newState;
}
